import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useWeekViewDomEffects = (visibleDateRange, selectedDate, addSurgeryDates) => {
    useEffectWithErrorLogging(() => {
        addNewActiveClass();
        componentCleanup();
        removeOtherRows();
        addSurgeryDates();
        // eslint-disable-next-line
    }, [visibleDateRange, selectedDate]);

    const removeOtherRows = () => {
        try {
            const weekRows = document.getElementsByTagName('tr');
            for (let weekRow in weekRows) {
                if (
                    weekRows[weekRow].className !== 'active-week' &&
                    weekRows[weekRow].parentElement.tagName !== 'THEAD'
                ) {
                    weekRows[weekRow].style = 'display:none';
                } else {
                    weekRows[weekRow].style = 'display:';
                }
            }
        } catch (error) {}
    };

    const addNewActiveClass = () => {
        const weekRows = document.getElementsByTagName('tr');
        for (let weekRow in weekRows) {
            const weekdays = weekRows[weekRow].childNodes;
            for (let weekday in weekdays) {
                if (weekdays[weekday].firstChild === undefined) {
                    break;
                } else if (
                    weekdays[weekday].firstChild.className === 'p-highlight'
                ) {
                    weekRows[weekRow].className = 'active-week';
                    break;
                } else {
                    weekRows[weekRow].className = '';
                    continue;
                }
            }
        }
    };

    const componentCleanup = () => {
        try {
            const x = document.getElementsByClassName('p-datepicker-header');
            for (let el in x[0].childNodes) {
                if (x[0].childNodes[el].tagName === 'BUTTON') {
                    x[0].removeChild(x[0].childNodes[el]);
                }
            }
            const title = document.getElementsByClassName('p-datepicker-title');
            title[0].style = 'display:none';
            const activeWeekCells = document.getElementsByClassName('active-week')[0].childNodes;
            for (let activeWeekCell in activeWeekCells) {
                if (
                    activeWeekCells[activeWeekCell].classList[0] ===
                    'p-datepicker-other-month'
                ) {
                    activeWeekCells[activeWeekCell].className = '';
                    activeWeekCells[activeWeekCell].firstChild.className = '';
                }
            }
        } catch (error) {}
    };
};

export default useWeekViewDomEffects;
